export default __webpack_public_path__ + "static/media/socoffee.de779cf9.png";